
export default {
  name: 'LocaleChanger',
  props: {
    value: {
      type: String,
      default: 'en'
    },
    availableLanguages: {
      type: Array,
      default () {
        return []
      }
    },
    useCustomList: Boolean,
    dropdownPosition: {
      type: String,
      default: 'right'
    },
    alignCenter: Boolean
  },
  data () {
    return {
      isOpen: false,
      language: this.value
    }
  },
  computed: {
    locales () {
      const locales = []

      if (this.useCustomList) {
        for (const locale of this.availableLanguages) {
          if (locale !== this.selectedLanguage) {
            locales.push({ code: locale })
          }
        }
      } else {
        for (const locale of this.$i18n.locales) {
          if (locale.code !== this.$i18n.locale) {
            locales.push(locale)
          }
        }
      }

      return locales
    },
    selectedLanguage () {
      if (this.useCustomList) {
        return this.language
      }

      return this.$i18n.locale
    }
  },
  watch: {
    value (newLanguage) {
      this.language = newLanguage
    }
  },
  methods: {
    selectLanguage (language) {
      if (this.useCustomList) {
        this.language = language
        this.$emit('input', this.language)

        return
      }

      this.$i18n.setLocale(language)
    }
  }
}
